"use client";

import enUS from "../translations/en-US.json";
import deDE from "../translations/de-DE.json";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { useAppStore } from "@/lib/store/app";

const translations = {
  "en-US": enUS,
  "de-DE": deDE,
};

export const useTranslation = () => {
  const { locale, setLocale, setLanguageLoading } = useAppStore();

  // Keep cookie in sync with store (covers edge case where detectLocale
  // used browser language but cookie write may have failed)
  useEffect(() => {
    const saved = Cookies.get("locale");
    if (saved !== locale) {
      Cookies.set("locale", locale);
    }
  }, [locale]);

  const t = (key: string, replacements?: Record<string, string | number>) => {
    const keys = key.split(".");
    let translation: any = translations[locale as keyof typeof translations];

    for (const k of keys) {
      if (!translation || translation[k] === undefined) return key;
      translation = translation[k];
    }

    if (typeof translation === "object") return key;

    let result = String(translation);

    if (replacements) {
      Object.entries(replacements).forEach(([placeholder, value]) => {
        result = result.replace(`{${placeholder}}`, String(value));
      });
    }

    return result;
  };

  const changeLanguage = (newLocale: string) => {
    if (
      (newLocale === "en-US" || newLocale === "de-DE") &&
      newLocale !== locale
    ) {
      setLanguageLoading(true);
      Cookies.set("locale", newLocale);
      setLocale(newLocale);
      setTimeout(() => setLanguageLoading(false), 100);
    }
  };

  return { t, locale, changeLanguage };
};
